import './GameInfo.css';
import GameInfo from './GameInfo';
export default GameInfo;



// WEBPACK FOOTER //
// ./src/components/Game/components/GameInfo/index.js